import { createReducer } from 'lib/utilities';
import mergeByProp from '../../../lib/mergeByProp.js';

const initialState = () => {
  return {
    stagePagination: {},
    pipelineStageDragActions: [],
    actions: {},
    scrollToPipelineLeadId: undefined,
  };
};

export default createReducer(initialState(), {
  pipelineSetScrollToPipelineLeadId: (state, payload) => ({ ...state, scrollToPipelineLeadId: payload }),
  pipelineClearPipelineStageDragActions: (state) => ({
    ...state,
    pipelineStageDragActions: [],
  }),
  pipelineSetPipelineStageDragAction: (state, payload) => {
    return {
      ...state,
      pipelineStageDragActions: mergeByProp('id', state.pipelineStageDragActions, [payload]),
    };
  },
  pipelineSetStagePagination: (state, { id, value }) => ({
    ...state,
    stagePagination: {
      ...state.stagePagination,
      [id]: value,
    },
  }),
  pipelineClearStagePagination: (state) => ({ ...state, stagePagination: {} }),
  updatePipelineLeadAction: (state, payload) => {
    const { actionId, pipelineLeadId, id, status } = payload;
    return {
      ...state,
      actions: {
        ...(state.actions || {}),
        [pipelineLeadId]: {
          ...(state.actions && state.actions[pipelineLeadId] ? state.actions[pipelineLeadId] : {}),
          [actionId]: {
            ...(state.actions && state.actions[pipelineLeadId] && state.actions[pipelineLeadId][actionId] ? state.actions[pipelineLeadId][actionId] : {}),
            [id]: status,
          },
        },
      },
    };
  },
});
